<div (click)="showPreviewImage()">
  <img [src]="imageUrl" [alt]="alt" [style.width.px]="currentWidth" />
</div>
